import { render, staticRenderFns } from "./UserCollection.vue?vue&type=template&id=52ce04b5&scoped=true"
import script from "./UserCollection.vue?vue&type=script&lang=js"
export * from "./UserCollection.vue?vue&type=script&lang=js"
import style0 from "./UserCollection.vue?vue&type=style&index=0&id=52ce04b5&prod&lang=scss&scoped=true"
import style1 from "./UserCollection.vue?vue&type=style&index=1&id=52ce04b5&prod&lang=scss"
import style2 from "./UserCollection.vue?vue&type=style&index=2&id=52ce04b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ce04b5",
  null
  
)

export default component.exports